import styles from "./styles.module.scss";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DocumentsFormProps, FilesType } from "../types";
import { request } from "../../../../services";
import { MergedColumnType } from "../../../ui/table/utils/types";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import { SessionContext } from "../../../../contexts/session/index.context";
import { ModalContext } from "../../../../contexts/modal/index.context";
import { FormContext } from "../../../../contexts/form/index.context";
import { TableContext } from "../../../../contexts/table/index.context";
import { useRowsTable } from "../../../../helpers/resolutionsContext/resolutionCtx";
//Components
import FileEditor from "../../../ui/file-editor";
import DocumentsForm from "../add";
import Modal from "../../../ui/modal";
import Directories from "../../../directories";
import Drawer from "../../../ui/drawer";
import { DrawerProvider } from "../../../../contexts/drawer/index.context";
import ExamplesModal from "../../../../helpers/modal_resolutions_zmist/examples_modal";
import TableResolutions from "../../../../helpers/table_resolutions_executor/table_resolutions_executor";
import checkIsAdmin from "../../../../helpers/checkIsAdmin";
//UI
import Space from "antd/lib/space";
import Typography from "antd/lib/typography";
import Checkbox from "antd/lib/checkbox";
import Col from "antd/lib/col";
import Tabs from "antd/lib/tabs";
import Tooltip from "antd/lib/tooltip";
import Button from "antd/lib/button";
import Form from "antd/lib/form";
import Select from "antd/lib/select";
import type { TabsProps } from "antd/es/tabs";
import { CloseCircleOutlined, CloseSquareFilled, CloseSquareOutlined, CloseSquareTwoTone, QuestionCircleOutlined, CloseOutlined, BookOutlined, ReadOutlined, BookTwoTone, FileTextOutlined, PlusOutlined } from '@ant-design/icons';
//Icons
import QuestionOutlined from "@ant-design/icons/QuestionOutlined";
import { DatePicker, Table } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { CLOSE_MESSAGE } from "../../../../store/actions";

import en from "antd/es/date-picker/locale/en_US";
import ua from "antd/es/date-picker/locale/uk_UA";

dayjs.extend(utc);


const { Title, Text } = Typography;

export default function EditDocumentsForm(props: DocumentsFormProps) {
  const location = useLocation();
  const { intl, language } = useContext(TranslationContext);

  const { form } = useContext(FormContext);
  // const { sessionData } = useContext(SessionContext);
  const {
    refreshFileEditor,
    setRefreshFileEditor,
    activeModal,
    disabled,
    setDisabled,
    setRefresh,
  } = useContext(ModalContext);
  const edit = activeModal === "edit";
  const { rowData, contextTableData, setContextTableData } = useContext(TableContext);
  const { sessionData, setSessionData, tableState, setTableState } = useContext(SessionContext);


  const [files, setFiles] = useState<FilesType[]>([]);
  const [resultData, setResultData] = useState<MergedColumnType[]>([]);



  // const [authorResolution, setAuthorResolution] = useState<number | undefined>(edit ? sessionData.Executors_FIO_id : undefined);
  // const [dateOfResolution, setDateOfResolution] = useState<string | undefined>(edit ? sessionData.ActionDate : undefined);


  // const dateFormatList = ["DD.MM.YYYY", "DD-MM-YYYY"];


  const formComponent = <DocumentsForm />;
  const isIncoming =
    location.pathname.split("/").pop() === "incoming" ||
    sessionData.eta_const_typedoc_id === 1;
  const isOutcoming =
    location.pathname.split("/").pop() === "outcoming" ||
    sessionData.eta_const_typedoc_id === 2;


  const isForSignature = props.url === "/documents/for-signature";
  const isResolutions = location.pathname.split("/").pop() === "resolutions";
    

  const text = (
    <span>
      ID: {sessionData.id} <br /> DocumentsID: {sessionData.bta_documents_id}
    </span>
  );

  const resultOptions = resultData?.map((item) => ({
    value: item.id,
    label: item.name,
    isSign: item.isSign,
  }));

  useEffect(() => {
    fetchFiles();
  }, []);


  useEffect(() => {
    if (refreshFileEditor) {
      fetchFiles();
      setRefreshFileEditor(false);
    }
  }, [refreshFileEditor]);

  useEffect(() => {
    if (sessionData.ActionResult_id && sessionData.ActionResult) {
      form.setFieldsValue({
        result: {
          value: sessionData.ActionResult_id,
          label: sessionData.ActionResult,
        },
      });
    }
  }, [sessionData]);



  const fetchFiles = async () => {
    const content = (
      await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/getfiles`,
        {
          method: "post",
          body: { id: sessionData.bta_documents_id },
          cancelTokenKey: "getfiles",
        }
      )
    )?.content;
    setFiles(content || []);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: intl("passing"),
      children: (
        <Directories
          url="/directories/passing"
          id={sessionData.bta_documents_id}
        />
      ),
    },
    {
      key: "2",
      label: intl("related"),
      children: (
        <Directories
          url="/directories/related-documents"
          id={sessionData.bta_documents_id}
        />
      ),
    },
    {
      key: "3",
      label: intl("discussion"),
      children: (
        <Directories
          url="/directories/discussion"
          id={sessionData.bta_documents_id}
        />
      ),
    },
  ];

  const fetchResultData = async () => {
    const content = (
      await request(`${props.url}/getresult`, {
        method: "get",
        cancelTokenKey: "getresult",
      })
    )?.content;
    setResultData(content || []);
  };

  // const onFinish = async (values: any) => {
  //   console.log("WTF ", values)
  // try {
  //   // console.log("Success:", values);

  //   if (activeModal === "edit") {
  //     values.id = sessionData.id;
  //   }

  //   await request(`${props.url}/updatedatatable2`, {
  //     method: "post",
  //     body: {
  //       documentId: sessionData?.bta_documents_id,
  //       page: props.url?.split("/").pop(),
  //       ...values,
  //     },
  //     cancelTokenKey: "updatedatatable",
  //   });
  //   activeModal !== "edit" && setDisabled({ ...disabled, edit: false });
  //   form.resetFields();
  //   setRefresh(true);
  //   props.onSubmitDone?.(true);
  // } catch (error) {
  //   props.onSubmitDone?.(false);
  // }
  // };


//   // "DD.MM.YYYY" -> "YYYY-MM-DDT00:00:00.000Z" (UTC-північ)
// const toServerISO = (dStr: string) => {
//   const d = dayjs(dStr, ["DD.MM.YYYY", "DD-MM-YYYY"], true);
//   return d.isValid()
//     ? dayjs.utc(d.format("YYYY-MM-DD") + "T00:00:00Z").toISOString()
//     : "";
// };


const isoToPickerValue = (iso?: string) => {
  if (!iso) return undefined;
  const m = dayjs(iso);
  return m.isValid() ? dayjs.utc(iso).local() : "";
};


    const onFinish = async (values: any) => {
    console.log("Finish_form:", values);
    const dateField = values.dateOfResolution as dayjs.Dayjs | undefined;

    const dateOfResolutionISO = dateField
      ? dayjs.utc(dateField.format("YYYY-MM-DD") + "T00:00:00Z").toISOString()
      : undefined;

    const payload = {
      ...values,
      childTable: fullList ?? [],
      dateOfResolution: dateOfResolutionISO,
      bta_document_id: sessionData.bta_documents_id,
      id: sessionData.id,
      Executors_FIO_id: sessionData.Executors_FIO_id,
    }
    console.log("Finish_form ============================================================================ :", payload);

  try {
    if (activeModal === "edit") {
      values.id = sessionData.id;
    }

    let response;
    const endpoint =
      activeModal === "edit" ? "updatedatatable" : "adddatatable";

    let route = props.url || location.pathname;

    if (sessionData?.eta_const_typedoc_id === 1) {
      route = "/documents/resolutions";
    }
    //  else if (sessionData?.eta_const_typedoc_id === 2) {
    //   route = "/documents/outcoming";
    // } else if (sessionData?.eta_const_typedoc_id === 3) {
    //   route = "/documents/internal";
    // }

    response = await request(`${route}/${endpoint}`, {
      method: "post",
      body: {
        documentId: sessionData?.bta_documents_id,
        page: props.url?.split("/").pop(),
        ...values,
        ...payload,
      },
      cancelTokenKey: endpoint,
    });
    // console.log("RESPONSEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE ", response);
    activeModal !== "edit" && setDisabled({ ...disabled, edit: false });
    if (response.success && response.data && response.data[0]) {
      setSessionData(response.data[0]);
      setTableState({ 
        ...tableState,
        selectedRow: response.data[0].id
      });
      // props.onSubmitDone?.(response.success);
    }
    if (response.success) {
      props.onSubmitDone?.(response.success);
      form.resetFields();
      setRefresh(true);
    } else {
      props.onSubmitDone?.(false);
      
    }
  } catch (error) {
      props.onSubmitDone?.(false);
  }
  };

  const onFinishFailed = (errorInfo: any) => {
    props.onSubmitDone?.(false);
    console.log("Failed edit documents:", errorInfo);
  };

  useEffect(() => {

  if (!sessionData) return;

  // console.log("sessionData ", sessionData);

  const values = {

    authorResolution:
      sessionData.Executors_FIO_id ??
      undefined,


    dateOfResolution: sessionData.ActionDate
      ? dayjs(sessionData.ActionDate, ["DD.MM.YYYY", "DD-MM-YYYY"])
      : undefined,

    action: actionId ?? undefined,
    
    id: sessionData.id ?? null,


    user_id: userId ?? null,

    text_rez: sessionData.DocContent ?? undefined,


  };

  form.resetFields();

  form.setFieldsValue(values);
}, [sessionData, edit]);





function setFormFields() {
  if (!rowData) return;
  const fields: any = {};

  if (rowData["/directories/employees"]) {
    const picked = rowData["/directories/employees"]; // { id, data: {...} }
    fields.authorResolution = picked.id; // ← зберігаємо у форму id
  }

    if (rowData["/directories/resolution-templates"]) {
    const picked = rowData["/directories/resolution-templates"];
    fields.text_rez = picked.data.text_rezoluzia; 
    getPerfomersTemplatesTemporary(picked.id)
    console.log("TEMPLATES === ", picked)
  }

  // if (rowData["/documents/resolutions"]) {
  //   const d = rowData["/documents/resolutions"].ActionDate;
  //   fields.dateOfResolution = d ? dayjs(d, ["DD.MM.YYYY", "DD-MM-YYYY"]) : undefined;
  // }
  fields.dateOfResolution = dateDoc
    ? dayjs(dateDoc.value, ["DD.MM.YYYY", "DD-MM-YYYY"], true)
    : undefined;

  form.setFieldsValue(fields);
}


const clear_zmist = ()=>{
form.resetFields(['text_rez']);
};


const [openDefModal, setOpentDefModal] = useState<boolean>(false);
const {setRowsTable, setRowsTable2, fullList, setFullList} = useRowsTable();

const openModalDefFunc = ()=>{
  console.log("OPEN MODAL ");
  setOpentDefModal(true)
};

const insert_zmist = (record:any)=> {
  form.resetFields(['text_rez']);
  form.setFieldsValue({'text_rez': record.text_rezoluzia});
  setOpentDefModal(false);
};

  // useEffect(() => {
  //   console.log("fullList STATE LIST  === ", fullList);
  // }, [fullList, setFullList]);

type Row = {
  key: React.Key;
  Controllers_id: number;
  Executor_type: number; 
  Executors_FIO_id: number;
  Executors_FIO_name: string;
  Executors_id: number;
  Executors_name: string;
  dateK_plan: string;
  eta_actions_doc_id: number;
  id: number;
  isMainExecutors: number;
  name_actions_doc: string;
  num_pp: number;
  parent_id: number | null;
  user_id: number | null;
  contact_person: string;
  Rez_Execurors_FIO_id: number;
  ExecutorFIO: string; 
  gta_executers_fio_id: number;
  bta_document_id: number;
  idNewRow: null;
  type_rec: number;
  exec_id: number;
};


  // const [temporaryList, setTmporaryList] = useState<Row[]>([])
  const [idTemp, setIdTemp] = useState<number | null>(null)
  // const [performersTemplates, setPreformersTemplates] = useState<Row[] | null>(null)
  const [temporaryActions, setTemporaryActions] = useState<any[]>([]);
  const [templatesZmist, setTemplatesZmist] = useState<any[]>([]);
  const [actionId, setActionId] = useState<object | null>(null);
  const [dateStr, setDateStr] = useState<any | null>(null)
  const [dateDoc, setDateDoc] = useState<any | null>(null)
  const [userId, setUserId] = useState<number | null>(null);


  useEffect(()=> {
    setIdTemp(sessionData?.id)
  }, [sessionData])

    useEffect(()=> {
      if(idTemp === null) return;

    const exec = async ()=> {
      await getExecutorsTemporary(idTemp);
      const user = await checkIsAdmin(location.pathname, "edit");
      setUserId(user.userId);
      await getZmistTemplayes(user.userId, sessionData.eta_const_typeDoc_id);
    };

    exec();
  }, [idTemp])


  async function getZmistTemplayes(user_id: number | null, type_doc_id: number | null) {
    const content = (
      await request(`/documents/resolutions/getdatatablezmisttemplate`, {
        method: "post",
        body: {user_id, type_doc_id},
        cancelTokenKey: "getdatatablezmist",
      })
    )?.content; 
    // console.log("CONTENT ZMIST", content);
    // setTmporaryList(content.map((item: Row)=>({...item, key: item.id})))

    setTemplatesZmist(content.map((item: any, index: number)=>({...item, key: index+1})))
  };


  async function getExecutorsTemporary(id:number | null) {
    const content = (
      await request(`/documents/resolutions/getdatatabletemporary`, {
        method: "post",
        body: {id},
        cancelTokenKey: "getdatatabletemporary",
      })
    )?.content; 
    // console.log("CONTENT ", content);
    // setTmporaryList(content.map((item: Row)=>({...item, key: item.id})))
    setRowsTable(content.map((item: Row)=>({...item, key: item.id, bta_document_id: sessionData.bta_documents_id, Executors_FIO_id: sessionData.Executors_FIO_id})))
  };

  async function getActionsTemporary() {
    const actions = (
        await request(`/documents/resolutions/getdatatableactions`, {
          method: "get",
          cancelTokenKey: "getdatatableactions",
      })
    )?.content;
    setTemporaryActions(actions)
    // console.log("ACTIONS ", actions);
  };

  async function getPerfomersTemplatesTemporary(id:number | null) {
    const content = (
      await request(`/documents/resolutions/getdatatableperformtemplate`, {
        method: "post",
        body: {id},
        cancelTokenKey: "getdatatabletemporaryperformers",
      })
    )?.content; 
    // console.log("PERFORMERStemplates ", content);
    const performersTemplate = content.map((perf: Row) => (
      perf = {...perf,
        key: perf.id,
        Executors_FIO_name: perf.ExecutorFIO ?? null,
        Executors_FIO_id: sessionData.Executors_FIO_id ?? null,
        Controllers_id: sessionData.Executors_FIO_id,
        name_actions_doc:  "",
        eta_actions_doc_id: 0,
        dateK_plan: "",
        bta_document_id: sessionData.bta_documents_id,
        parent_id: null,
        isMainExecutors: 0,
        user_id: userId ?? null,
        idNewRow: null,
        Executor_type: perf.type_rec,
        Executors_id: perf.exec_id,
      }
    ));
    // console.log("PERFORMERStemplates update", performersTemplate);

    // setTmporaryList((prev) => [...prev, ...performersTemplate])
    setRowsTable2(performersTemplate.map((item: Row)=>({...item, key: item.id})))
  };


type Option = { value: number; label: string };


const resultActions: Option[] = temporaryActions?.map(item => ({
  value: item.id,
  label: item.name,
})) ?? [];


const documentDate = isoToPickerValue(sessionData.DocDate);

  return ( !isResolutions ? 
        (
          <Space className={styles["space"]} align="start" size={"large"}>
            <FileEditor files={files} url={props.url} />
            <div>
              {!isForSignature ? (
                <Modal name="edit" width={700}>{formComponent}</Modal>
              ) : (
                <div
                  style={{ display: "flex", justifyContent: "flex-end", padding: 10 }}
                >
                  <Tooltip placement="left" title={text}>
                    <Button shape="circle" icon={<QuestionOutlined />} />
                  </Tooltip>
                </div>
              )}
              <div className={styles["header-text"]}>
                <Text style={{ fontSize: 20 }}>{sessionData.typeDocName}</Text>
                <div>
                  {isForSignature && intl("permission")} {""}
                  <Text strong style={{ marginRight: 6 }}>
                    №
                  </Text>
                  <Text style={{ marginRight: 20 }}>{sessionData.DocNum}</Text>
                  <Text strong style={{ marginRight: 6 }}>
                    {intl("from")}
                  </Text>
                  <Text>{sessionData.DocDate}</Text>
                </div>
              </div>
              {!isIncoming && !isForSignature && (
                <Checkbox checked={sessionData.isProject || sessionData.fProject}>
                  {intl("project")}
                </Checkbox>
              )}
              <div className={styles["text"]}>
                <Col span={4}>
                  <Text strong>{intl("content")}:</Text>
                </Col>
                <Text>{sessionData.Content}</Text>
              </div>
              {(isIncoming) && (
                <div className={styles["text"]}>
                  <Col span={4}>
                    <Text strong>{intl("correspondent")}:</Text>
                  </Col>
                  <Text>{sessionData.kontragentName}</Text>
                </div>
              )}
              {(isOutcoming) && (
                <div className={styles["text"]}>
                  <Col span={4}>
                    <Text strong>{intl("correspondent")}:</Text>
                  </Col>
                  <Text>{sessionData.kontragent_name}</Text>
                </div>
              )}
              {isIncoming ? (
                <>
                  <div className={styles["text"]}>
                    <Col span={4}>
                      <Text strong>{intl("num-output")}:</Text>
                    </Col>
                    <Text>{sessionData.DocNum}</Text>
                  </div>
                  <div className={styles["text"]}>
                    <Col span={4}>
                      <Text strong>{intl("from")}:</Text>
                    </Col>
                    <Text>{sessionData.DocDate}</Text>
                  </div>
                  <div className={styles["text"]}>
                    <Col span={4}>
                      <Text strong>{intl("addressed")}:</Text>
                    </Col>
                    <Text>{sessionData.FIO}</Text>
                  </div>
                </>
              ) : (
                <>
                  {!isForSignature && (
                    <div className={styles["text"]}>
                      <Col span={4}>
                        <Text strong>{intl("author")}:</Text>
                      </Col>
                      <Text>{sessionData.FIO || sessionData.Author}</Text>
                    </div>
                  )}
                  <div className={styles["text"]}>
                    <Col span={4}>
                      <Text strong>{intl("the-signatory")}:</Text>
                    </Col>
                    <Text>{sessionData.SignFIO}</Text>
                  </div>
                  {isForSignature && (
                    <div className={styles["text"]}>
                      <Col span={4}>
                        <Text strong>{intl("result")}:</Text>
                      </Col>
                      <Form
                        className={styles["form"]}
                        name="result"
                        form={form}
                        // onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                      >
                        <Form.Item
                          name="result"
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select
                            allowClear
                            onChange={(_, value) => {
                              form.setFieldsValue({ result: value });
                            }}
                            onDropdownVisibleChange={fetchResultData}
                            options={resultOptions}
                          />
                        </Form.Item>
                      </Form>
                    </div>
                  )}
                </>
              )}

              {!isForSignature && (
                <Tabs className={styles["tabs"]} defaultActiveKey="1" items={items} />
              )}
            </div>
          </Space> 
          ) : (
          <Space className={styles["space"]} align="start" size={"large"}>

            <FileEditor files={files} url={props.url} />
              <div>
                <div className={styles["question_mark"]}>
                  <Tooltip title={<>ID: {sessionData.id}<br/>Documents ID: {sessionData.bta_documents_id}</>} placement="left" >
                    {<QuestionCircleOutlined />}
                  </Tooltip>
                </div>
                <div className={styles["header-text"]} style={{marginBottom: "20px"}}>
                  <Text style={{ fontSize: 20 }}>{sessionData.typeDocName}</Text>
                    <div>
                      <Text strong style={{ marginRight: 6 }}>{intl("letter")}{" "}№</Text>
                            <Text style={{ marginRight: 20 }}>{sessionData.DocNum}</Text>
                            <Text strong style={{ marginRight: 6 }}>{intl("from")}</Text>
                            <Text>{documentDate ? documentDate.format("DD.MM.YYYY") : ""}</Text>
                    </div>
                </div>
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: "20px" }}>
                    <DrawerProvider>
                      <Text className={styles["text"]} strong>{intl("author-resolution")}:</Text>
                      <Form.Item name="authorResolution" style={{ margin: 0, flex: 1, width: "75%" }}>
                        <Drawer
                          url="/directories/employees"
                          name={edit ? sessionData.ActionPerson : undefined}
                          name2={rowData["/directories/employees"]?.data.fio}
                          setFormFields={setFormFields}
                          fieldName="authorResolution"
                        >
                          <Directories
                            url="/directories/employees"
                            selectedRowId={form.getFieldValue("authorResolution")}
                          />
                        </Drawer>
                      </Form.Item>

                      <Text className={styles["text"]} strong>{intl("date-of-provision")}:</Text>
                      <Form.Item name="dateOfResolution" style={{ margin: 0, width: "25%" }}>
                        <DatePicker
                          onChange={(_, dateString)=> setDateStr(dateString)}
                          format={["DD.MM.YYYY", "DD-MM-YYYY"]}
                          style={{ width: "100%" }}
                          placeholder={intl("choose-date-placeholder")}
                          locale={language ? ua : en}
                        />
                      </Form.Item>
                    </DrawerProvider>
                  </div>

                  <div style={{ display: "flex", gap: 5, alignItems: "start", marginBottom: "20px"}}>
                    <Text className={styles["text"]} strong>{intl("content-label")}:</Text>
                    <Form.Item name="text_rez" style={{ margin: 0, flex: 1, width: "100%"}} rules={[{ required: true }]}>
                      <TextArea autoSize style={{width: "100%"}} />
                    </Form.Item>
                      <div className={styles["clear_btn"]} onClick={()=>openModalDefFunc()}>
                        <PlusOutlined style={{fontSize: "16px"}} />
                      </div>
                      <div>
                        <Drawer
                          hidden={true}
                          newIco={true}
                          url="/directories/resolution-templates"
                          name={undefined}
                          setFormFields={setFormFields}
                          fieldName="text_rez"
                        >
                          <Directories
                          // id={sessionData.id}
                            url="/directories/resolution-templates"
                            // selectedRowId={form.getFieldValue("authorResolution")}
                          />
                        </Drawer>
                      </div>
                      <div className={styles["clear_btn"]} onClick={clear_zmist}>
                        <CloseOutlined style={{fontSize: "16px"}} />
                      </div>

                  </div>

                  <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: "20px" }}>
                    <Text className={styles["text"]} strong>{intl("action-label")}:</Text>
                    <Form.Item name="action" style={{ margin: 0, flex: 1 }} /*rules={[{ required: true }]}*/ >
                      <Select allowClear onDropdownVisibleChange={getActionsTemporary} options={resultActions} onChange={(value, option) => {setActionId(option)}} style={{width: "370px"}} placeholder={intl("choose-action")}/>
                    </Form.Item>

                    <Text className={styles["text"]} strong>{intl("date-of-control-action")}:</Text>
                    <Form.Item name="dateOfControl" style={{ margin: 0, width: "25%" }}>
                      <DatePicker
                        format={["DD.MM.YYYY", "DD-MM-YYYY"]}
                        style={{ width: "100%" }}
                        placeholder={intl("choose-date-placeholder")}
                        onChange={(_, dateString) => setDateStr(dateString)}
                        locale={language ? ua : en}
                      />
                    </Form.Item>
                  </div>
                </Form>



                {/* {!isForSignature && (
                <Tabs className={styles["tabs"]} defaultActiveKey="1" items={items} />
                )} */}
                <TableResolutions userID={userId} action={actionId} date={dateStr}/>
              </div>
                <ExamplesModal zmist={templatesZmist} openModalProp={openDefModal} onClose={()=>setOpentDefModal(false)} onPick={(row)=>insert_zmist(row)}/>
          </Space> 
        )
      );
    }
